import type { Deal, Promo } from '../../../../types/Deal';
import type { Widget } from '../../../../types/Widget';
import { WidgetType } from '../../../../types/WidgetType';
import type Localiser from '../../../Localiser';

import { addCustomPromos } from './addCustomPromos';
import { addWasPricePromos } from './addWasPricePromos';

const getFilteredPromos = ({
  excludeFrom,
  localiser,
  widget,
  promos,
  showPromos,
}: {
  excludeFrom?: string;
  localiser: Localiser;
  widget: Widget;
  promos: Promo[];
  showPromos?: boolean;
}): Promo[] => {
  // if excludeFrom is set to all in the CMS set promos to REPORTED OUT OF STOCK
  if (excludeFrom) {
    return [
      {
        value: localiser.translate('reportedOutOfStockPromo'),
        display_value: localiser.translate('reportedOutOfStockPromo'),
        type: '',
      },
    ];
  }

  // Remove bundle promos for the bundle widget - this avoids showing them in 2 places
  if (widget.type === WidgetType.BUNDLE) {
    return promos.filter((promo) => promo.type !== 'bundle');
  }

  // Remove the promos if the showPromos feature is disabled
  if (!showPromos) {
    return [];
  }

  return promos;
};

export const getPromos = ({
  showWasPrice,
  localiser,
  deal,
  customPromo,
  customPromos,
  excludeFrom,
  showPromos,
  widget,
}: {
  showWasPrice?: string;
  localiser: Localiser;
  deal: Deal;
  customPromo?: string;
  customPromos?: string;
  excludeFrom?: string;
  showPromos?: boolean;
  widget: Widget;
}): Promo[] => {
  /* Add reduced price promo if there is a was price & the promo
  feature or all was price features are enabled */
  const wasPricePromos = addWasPricePromos({
    showWasPrice,
    localiser,
    deal,
  });

  // Add the custom promos to promos for the deal widget if set in the CMS by the editor
  const customWasPricePromos = addCustomPromos({
    localiser,
    customPromo,
    customPromos,
    promos: wasPricePromos,
  });

  // Do not display promos in certain use cases
  return getFilteredPromos({
    localiser,
    excludeFrom,
    promos: customWasPricePromos,
    showPromos,
    widget,
  });
};
